import {
	AlertSubscriptionCell,
	SeverityCell,
	VisibilityCell,
	SubscriptionsCell,
	SubscribedCell,
} from 'features/IRWorkstation/components/AlertCenter/AlertSubscriptionList/AlertSubscriptionColumnDisplay';

// -------------------------------------------------------------------------
// All Columns
// -------------------------------------------------------------------------

export const AlertSubscriptionColumnDefinitions = ({
	handleSubscribe,
	handleUnsubscribe,
	expandedRowIds,
	onToggleRule,
} = {}) => [
	{
		field: 'title',
		headerName: 'Alert',
		editable: false,
		sortable: false,
		flex: 5,
		minWidth: 300,
		renderCell: (params) => (
			<AlertSubscriptionCell
				params={params}
				isRuleExpanded={expandedRowIds?.includes(params.row.id)}
				onToggleRule={onToggleRule}
			/>
		),
	},
	{
		field: 'severity',
		headerName: 'Severity',
		editable: false,
		sortable: false,
		flex: 1,
		minWidth: 100,
		display: 'flex',
		renderCell: (params) => <SeverityCell params={params} />,
	},
	{
		field: 'visibility',
		headerName: 'Visibility',
		editable: false,
		sortable: false,
		flex: 1,
		minWidth: 100,
		display: 'flex',
		renderCell: (params) => <VisibilityCell params={params} />,
	},
	{
		field: 'subscription_count',
		headerName: 'Subscriptions',
		editable: false,
		sortable: false,
		flex: 1,
		minWidth: 140,
		display: 'flex',
		renderCell: (params) => <SubscriptionsCell params={params} />,
	},
	{
		field: 'subscribed',
		headerName: 'Subscribed',
		editable: false,
		sortable: false,
		resizable: false,
		flex: 1,
		minWidth: 120,
		display: 'flex',
		renderCell: (params) => (
			<SubscribedCell
				params={params}
				handleSubscribe={handleSubscribe}
				handleUnsubscribe={handleUnsubscribe}
			/>
		),
	},
];
